import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Hammer, LayoutDashboard, Briefcase, Users, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
interface LayoutProps {
  children: ReactNode;
}
const Layout = ({
  children
}: LayoutProps) => {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    toast.success("Signed out successfully");
    navigate("/auth");
  };
  return <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        
      </header>

      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
    </div>;
};
export default Layout;